
interface Step {
  number: number;
  title: string;
  description: string;
}

interface ProgressBarProps {
  steps: Step[];
  currentStep: number;
}

export default function ProgressBar({ steps, currentStep }: ProgressBarProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-center">
        <div className="flex items-center justify-between max-w-md w-full">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-instrument font-semibold text-sm ${
                    step.number <= currentStep
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {step.number <= currentStep ? (
                    step.number < currentStep ? (
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-check-line text-primary-foreground"></i>
                      </div>
                    ) : (
                      step.number
                    )
                  ) : (
                    step.number
                  )}
                </div>
                <div className="text-center mt-2">
                  <div
                    className={`text-sm font-instrument font-medium whitespace-nowrap ${
                      step.number <= currentStep ? 'text-primary' : 'text-gray-500'
                    }`}
                  >
                    {step.title}
                  </div>
                  <div className="text-xs font-instrument text-textSecondary whitespace-nowrap">
                    {step.description}
                  </div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`w-24 h-0.5 mx-4 ${
                    step.number < currentStep ? 'bg-primary' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
